class ArticleResults extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.articleResults = this.querySelector('[data-article-results]');
    this.searchTerm = this.querySelector('#search-terms');
  }

  connectedCallback() {
    this.getSearchResults(this.searchTerm.value);
  }

  async getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    await fetch(`/search?q=${encodeURIComponent(searchTerm)}&options%5Bprefix%5D=last&type=article`)
      .then(response => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const getArticles = html.querySelector('#ArticleResults').innerHTML;

        this.cachedResults[queryKey] = getArticles;
        this.renderSearchResults(getArticles);
      })
      .catch((error) => {
        throw error;
      });
  }

  renderSearchResults(getArticles) {
    this.articleResults.innerHTML = getArticles;
    this.setAttribute('results', true);
  }
}

customElements.define('article-results', ArticleResults);

class ResultsQuickFilter extends HTMLElement {
  constructor() {
    super();

    this.pageNums = document.querySelectorAll('.link[aria-pagenumber]');
    this.allFilter = document.querySelector('[data-all-filter]');
    this.productFilter = document.querySelector('[data-product-filter]');
    this.contentFilter = document.querySelector('[data-content-filter]');
    this.fullGrid = document.getElementById('collection__grid');

    this.allFilter.addEventListener("click", () => {
      this.filterSwitch('all');
      this.renderAll();
    });
  
    this.productFilter.addEventListener("click", () => {    
      this.filterSwitch('store');
      this.renderProductsOnly();
    });
  
    this.contentFilter.addEventListener("click", () => {
      this.filterSwitch('blog'); 
      this.renderContentsOnly();
    });
  }

  filterSwitch(newFilter) {
    const url = new URL(window.location);

    if (newFilter !== 'blog') {
      url.searchParams.set('type', 'product');

      this.pageNums && this.pageNums.forEach((pageNum) => {
        const linkRef = pageNum.getAttribute('href');
        const split = linkRef.split('?');
        if (Array.isArray(split) && split.length === 2) {
          const path = split[0];
          const searchString = split[1];
          const qs = new URLSearchParams(searchString);

          qs.set('filter', newFilter);
          const newHref = path + '?' + qs.toString();
          pageNum.setAttribute('href', newHref);
        }
      });
    }
    
    url.searchParams.set('filter', newFilter);    
    window.history.pushState(null, '', url.toString());
  }

  connectedCallback() {
    const urlParams = new URLSearchParams(window.location.search);
    const filterParam = urlParams.get('filter');

    if (filterParam == 'store') {
      this.renderProductsOnly();
    } else if (filterParam == 'blog') {
      this.renderContentsOnly();
    } else {
      this.renderAll();
    }
  }

  renderAll() {
    this.fullGrid.classList.remove('filter-blog');
    this.fullGrid.classList.remove('filter-store');
    this.fullGrid.classList.add('filter-all');
    this.allFilter.classList.add('active');
    this.productFilter.classList.remove('active');
    this.contentFilter.classList.remove('active');
  }

  renderProductsOnly() {
    this.fullGrid.classList.remove('filter-all');
    this.fullGrid.classList.remove('filter-blog');
    this.fullGrid.classList.add('filter-store');
    this.productFilter.classList.add('active');
    this.contentFilter.classList.remove('active');
    this.allFilter.classList.remove('active');
  }

  renderContentsOnly() {
    this.fullGrid.classList.remove('filter-all');
    this.fullGrid.classList.remove('filter-store');
    this.fullGrid.classList.add('filter-blog');
    this.contentFilter.classList.add('active');
    this.allFilter.classList.remove('active');
    this.productFilter.classList.remove('active');

  }
}

customElements.define('results-quick-filter', ResultsQuickFilter);
